import { ChangeDetectorRef, EventEmitter, Output } from "@angular/core";
import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { FormGroup, FormArray, FormBuilder, FormControl } from "@angular/forms";
import { DeviceService } from "../service/device.service";
import { Log } from "../util/log";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from "@angular/material/dialog";

@Component({
  selector: 'app-move-bollard-dialog',
  templateUrl: './move-bollard-dialog.component.html',
  styleUrls: ['./move-bollard-dialog.component.css']
})
export class MoveBollardDialogComponent implements OnInit {

  newAddress: string = "";

  constructor(
    public dialogRef: MatDialogRef<MoveBollardDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private deviceService: DeviceService,
    private cdRef: ChangeDetectorRef,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
  }


  savenewAddress() {
    if (this.newAddress != "") {
      let data;
      // coordinates = this.deviceService.getCoordinatesOfLocation(this.newAddress).subscribe();
      this.deviceService.getCoordinatesOfLocation(this.newAddress).subscribe(result => {
        data = result;
        Log.debug("Coordinates: ");
        Log.debug(data);

        Log.debug(data.results[0].geometry.location.lat);
        Log.debug(data.results[0].geometry.location.lng);

        let coordinates = [data.results[0].geometry.location.lat, data.results[0].geometry.location.lng];
        this.dialogRef.close(coordinates);
      });
    } else {
      this.dialogRef.close("no data");
    }
  }


  closeDialog() {
    this.dialogRef.close();
  }
}


